import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import auth from "../../services/authService";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import UploadRepository from "../../app/components/Document/UploadRepository";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import {
  ddrmsRepoDocumentUploaded,
  getDdrmsRepositoryDocuments,
  getDdrmsRepoUploadStatus,
  loadDdrmsRepositoryDocs,
  UploadDdrmsRepositoryDocs,
} from "../../app/store/ddrmsDocument";
import {
  getLocalDocUploadSasUrl,
  getLocalDocUploadStatus,
  getUploadDocumentId,
  localDocumentUploaded,
  uploadDocument,
  uploadLocalDocument,
} from "../../app/store/documents";
import UploadLocal from "../../app/components/Document/UploadLocal";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../app/store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../app/store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../app/store/candidate";

const CandidateReqDoc = (props) => {
  const {
    docShowHide,
    handleDocShowHide,
    sendType,
    workItem,
    uploadType,
    applicantObj,
    viewType,
    uploadDocType,
    prevItem
  } = props;

  const [submitProcess, setSubmitProcess] = useState(false);
  const [useType, setUseType] = useState("sharing");
  const [isPwd, setIsPwd] = useState("");
  const [message, setMessage] = useState("");
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [localDocs, setLocalDocs] = useState([]);
  const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
  const [wfTask, setWfTask] = useState(null);
  const [repoDocs, setRepoDocs] = useState([]);

  const ddrmsRepoUploadStatus = useSelector(getDdrmsRepoUploadStatus);
  const localDocUploadStatusSelector = useSelector(getLocalDocUploadStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);


  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    setMessage("");
    setLocalDocs([]);
    setSelectedRepoDocs([]);
    setIsPwd("");
    setUseType("");
  }, [docShowHide]);

  console.log(props);

  useEffect(() => {
    if (workItem?.ciid > 0) {
      if (sendType === "repository")
        dispatch(loadDdrmsRepositoryDocs(workItem.ciid));
      setWfTask(workItem);
    }
    else if (applicantObj?.id) {
      if (prevItem?.applications?.length > 0 && sendType === "repository")
        dispatch(loadDdrmsRepositoryDocs(prevItem.applications[0].ciid));

      if (uploadType === "Subcontractor") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.subcontractor?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Recruiter") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.recruiter?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadRecruiterWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Candidate") {
        dispatch(loadCandidateWfTask(applicantObj?.id));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
  }, [])

  useEffect(() => {
    console.log(subsCurrentWfTaskSelector)
    if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
      setWfTask(subsCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    }
    else if (subsCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(subsCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    console.log(recCurrentWfTaskSelector)
    if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
      setWfTask(recCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    } else if (recCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(recCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadRecruiterWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [recCurrentWfTaskSelector]);

  useEffect(() => {
    console.log(candidateCurrentWfTaskSelector)
    if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
      setWfTask(candidateCurrentWfTaskSelector)
      setWfTaskReqCount(0)
    } else if (candidateCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      setWfTaskReqCount(wfTaskReqCount + 1)
      dispatch(candidateCurrentWfTaskReceived(null));
      setTimeout(() => {
        dispatch(loadCandidateWfTask(applicantObj?.id));
      }, 1000);
    }
  }, [candidateCurrentWfTaskSelector]);


  useEffect(() => {
    setRepoDocs(ddrmsRepositoryDocumentsSelector);
  }, [ddrmsRepositoryDocumentsSelector]);

  const doSubmit = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Upload this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setSubmitProcess(true);
      setTimeout(() => {
        let docType = "";
        if (uploadType) docType = uploadType;
        if (uploadDocType) docType = uploadDocType;
        if (sendType === "repository") saveRepoDocs(docType);
        if (sendType === "upload") saveLocalDocs(docType);
      }, 1000);
    }
  };

  const saveRepoDocs = async (docType) => {
    let task = { ...wfTask };
    task.performerId = currentUser.id;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.applicantId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        task.applicantId = applicantObj.applicantId;
        task.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      task.applicantId = applicantObj?.id;
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(task));
    frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    //frmData.append("userId", usrId);
    const updDocs = selectedRepoDocs.map((doc) => {
      const newDoc = { ...doc };
      newDoc.docType = docType;
      return newDoc;
    });
    frmData.append("doc", JSON.stringify(updDocs));
    dispatch(UploadDdrmsRepositoryDocs(frmData));
  };

  useEffect(() => {
    if (ddrmsRepoUploadStatus) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
      dispatch(ddrmsRepoDocumentUploaded({ status: false }));
    }
  }, [ddrmsRepoUploadStatus]);

  const saveLocalDocs = async (docType) => {
    const task = { ...wfTask };
    //wfTask.performerId = workItem.applicantId;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.performerId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.performerId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.performerId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        usrId = applicantObj.applicantId;
        task.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      task.performerId = applicantObj?.id;
    }

    if (docType?.includes("req_")) {
      usrId = task.performerId;
      task.performerId = parseInt(currentUser.id);
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid) {
        usrId = applicantObj.recruiter.parentid;
        task.performerId = applicantObj?.id;
      }
      if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid) {
        usrId = applicantObj.subcontractor.parentid;
        task.performerId = applicantObj?.id;
      }
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(task));
    frmData.append("userId", usrId);
    // localDocs.map((file, key) =>
    //   frmData.append("files[" + key + "]", file.file)
    // );
    frmData.append("files", JSON.stringify(localDocs.map((file) => ({ name: file.name, type: file.type, size: file.size }))));
    frmData.append("docType", docType);
    if (!useType) frmData.append("updType", docType);
    else frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    dispatch(uploadLocalDocument(frmData));

  };

  useEffect(() => {
    if (localDocUploadStatusSelector > 0) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
    }
  }, [localDocUploadStatusSelector]);

  useEffect(() => {

    const uploadAllDocuments = async () => {
      if (localDocUploadSasUrlSelector && localDocUploadSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            localDocs.map((file, key) =>
              uploadFileToBlob(
                file.file,
                localDocUploadSasUrlSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          // Runs only after ALL uploads finish   
          console.log("All files uploaded successfully!");
          dispatch(localDocumentUploaded(null));
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [localDocUploadSasUrlSelector]);

  const handlePwdChecked = ({ currentTarget }) => {
    if (currentTarget.checked) {
      if (uploadType === "Subcontractor") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.subcontractor.fuid;
          const pfName = applicantObj.subcontractor.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Recruiter") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.recruiter.fuid;
          const pfName = applicantObj.recruiter.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Candidate") {
        const pfId = applicantObj.performerid;
        const pfName = applicantObj.performername.substring(0, 3).toLowerCase();
        setIsPwd(pfName + pfId);
      }
    } else {
      setIsPwd("");
    }
  };

  const handleUseTypeSelect = ({ currentTarget }) => {
    if (currentTarget.checked) setUseType("internal");
    else setUseType("sharing");
  };

  return (
    <Modal show={docShowHide} size="xl">
      <Modal.Header closeButton onHide={() => handleDocShowHide("")}>
        <Modal.Title>
          {sendType === "repository"
            ? "Upload from DDRMS Repository"
            : "Upload from Local Drive"}{" "}
          - {uploadType?.toUpperCase()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          {sendType === "repository" && (
            <UploadRepository
              repoDocs={repoDocs}
              setSelectedRepoDocs={setSelectedRepoDocs}
            />
          )}

          {sendType === "upload" && (
            <div className="col-md-12">
              <UploadLocal setLocalDocs={setLocalDocs} />
            </div>
          )}
          {!(
            uploadType === "msp" ||
            uploadType === "agency" ||
            uploadType === "ProjectInfo" ||
            uploadType?.includes("ach_") ||
            uploadType?.includes("insurance_") ||
            uploadDocType?.includes("req_") ||
            uploadDocType === "reporting"
          ) && (
              <>
                <>
                  <div className="col-md-12 form-inline form-group">
                    <div className="custom-control custom-checkbox">
                      <input
                        name="useType"
                        className="custom-control-input"
                        id="internal"
                        value="internal"
                        type="checkbox"
                        onChange={handleUseTypeSelect}
                        checked={useType === "internal"}
                      />
                      <label className="custom-control-label" htmlFor="internal">
                        For Internal Purposes Only
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="custom-control custom-checkbox mb-3">
                      <input
                        className="custom-control-input"
                        id="isPwd"
                        name="isPwd"
                        type="checkbox"
                        onChange={handlePwdChecked}
                      />
                      <label className="custom-control-label" htmlFor="isPwd">
                        Check Box if you want the document to sent as password
                        protected
                      </label>
                      <p className="text-danger">
                        (Example : First 3 letters of applicant's name and
                        starting 3 charactors of the applicant's ID in lower case)
                        (abc123).
                      </p>
                    </div>
                  </div>
                </>

                <div className="col-md-12">
                  <label htmlFor="message" className="form-control-label">
                    Notes
                    <span className="font-weight-normal ml-2">
                      (Add any additional message you may want to send)
                    </span>
                  </label>

                  <textarea
                    className="form-control"
                    id="message"
                    name="massage"
                    placeholder="Notes"
                    onChange={({ currentTarget }) =>
                      setMessage(currentTarget.value)
                    }
                    value={message}
                  ></textarea>
                </div>
              </>
            )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <button className="btn btn-sm btn-outline-default" onClick={() => handleDocShowHide("")}>
          <i class="fa fa-times" aria-hidden="true"></i> Close
        </button> */}
        <button
          className="btn btn-sm btn-outline-default"
          disabled={
            submitProcess ||
            (sendType === "repository" && selectedRepoDocs.length === 0) ||
            (sendType === "upload" && localDocs.length === 0)
          }
          onClick={doSubmit}
        >
          {submitProcess ? (
            <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
          ) : (
            <i class="fa fa-check" aria-hidden="true"></i>
          )}{" "}
          Attach
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CandidateReqDoc;
